var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconExport = function SvgIconExport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.82 8.68 6.18h2.5v7.5h1.64v-7.5h2.5zm5 18.36H7a1.734 1.734 0 0 1-1.68-1.68v-10A1.734 1.734 0 0 1 7 7.82h2.5V9.5H7v10h10v-10h-2.5V7.82H17a1.734 1.734 0 0 1 1.68 1.68v10A1.734 1.734 0 0 1 17 21.18"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconExport);
export { ForwardRef as ReactComponent };